<script lang="ts">
	import classNames from 'classnames';

	import { LazyMarkdown } from '../../../../components/LazyMarkdown';
	import type { MarkdownTokenList } from '../../../../components/Markdown';
	import { Txt } from '../../../../components/Txt';
	import { getTransformedMarkdown } from '../../../../utils/getTransformedMarkdown/getTransformedMarkdown';
	import { PdpDescriptionsParagraphs } from './PdpDescriptionsParagraphs';
	import { PdpShortDescription } from './PdpShortDescription';

	let {
		clamp = false,
		dataCy,
		longDescription,
		shortDescription = undefined,
		longDescriptionTokens = undefined,
		shortDescriptionTokens = undefined,
		markdown = false,
		readMore = $bindable(false),
		...rest
	}: Props = $props();

	interface Props {
		clamp?: boolean | undefined;
		dataCy: string;
		longDescription: string | null | undefined;
		shortDescription?: string | null | undefined;
		/**
		 * With `markdown`: the descriptions already transformed
		 * (getTransformedMarkdown) and parsed on the server (lexMarkdown), rendered
		 * instead of parsing the strings, which still decide what is shown.
		 */
		longDescriptionTokens?: MarkdownTokenList | undefined;
		shortDescriptionTokens?: MarkdownTokenList | undefined;
		markdown?: boolean | undefined;
		readMore?: boolean;
		class?: string;
	}

	let dataCyPrefix = $derived(`${dataCy}-pdp-description`);

	const toggleReadMore = () => {
		readMore = !readMore;
	};
</script>

<div data-cy={dataCyPrefix} class={rest.class}>
	{#if markdown}
		{#if longDescription && (!shortDescription || readMore)}
			<LazyMarkdown
				source={longDescriptionTokens ?? getTransformedMarkdown(longDescription)}
				dataCy={dataCyPrefix}
				class={classNames({
					'max-h-[6rem] overflow-hidden': !readMore && clamp
				})}
			/>
		{:else}
			<LazyMarkdown
				source={shortDescriptionTokens ?? getTransformedMarkdown(shortDescription)}
				dataCy={dataCyPrefix}
			/>
		{/if}
	{:else if longDescription && (!shortDescription || readMore)}
		<PdpDescriptionsParagraphs {longDescription} dataCy={dataCyPrefix} />
	{:else}
		<PdpShortDescription {shortDescription} dataCy={dataCyPrefix} />
	{/if}

	{#if clamp || (shortDescription && longDescription && shortDescription !== longDescription)}
		<button
			data-cy={`${dataCyPrefix}-read-more-button`}
			onclick={toggleReadMore}
			class={classNames('underline', { 'mt-6': clamp && !readMore })}
		>
			<Txt data-cy={`${dataCyPrefix}-read-more`} variant="body1" class="text-gray-700"
				>{readMore ? 'Read Less' : 'Read More'}</Txt
			>
		</button>
	{/if}
</div>
